import React from 'react';

const ShareScreenIcon = (props) => {
  let fill = props.fill ? props.fill : '#000';
  let fillOpacity = props.fill ? 1 : 0.38;

  return (
    <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0351 49.232H12.6025C9.5233 49.232 7.02795 46.7971 7.02795 43.7931V20.2225C7.02795 17.218 9.5233 14.7832 12.6025 14.7832H53.4814C56.5601 14.7832 59.0559 17.218 59.0559 20.2225V43.7931C59.0559 46.7971 56.5601 49.232 53.4814 49.232H46.0488V50.6463C46.0488 52.8692 44.2019 54.6713 41.9217 54.6713H24.1611C21.8814 54.6713 20.0343 52.8692 20.0343 50.6463L20.0351 49.232ZM23.7513 49.232V50.6463C23.7513 50.8659 23.9352 51.0453 24.1619 51.0453H41.9224C42.1491 51.0453 42.3335 50.8659 42.3335 50.6463V49.232H23.7513ZM33.9091 27.7902L37.551 32.6461C37.8384 33.0292 38.3819 33.1069 38.765 32.8195C39.1481 32.5322 39.2258 31.9887 38.9384 31.6056L35.123 26.5184C34.0825 25.131 32.0014 25.131 30.9608 26.5184L27.1454 31.6056C26.8581 31.9887 26.9357 32.5322 27.3189 32.8195C27.702 33.1069 28.2455 33.0292 28.5328 32.6461L32.1748 27.7902V39.0629C32.1748 39.5418 32.563 39.93 33.0419 39.93C33.5208 39.93 33.9091 39.5418 33.9091 39.0629V27.7902Z"
        fill={fill}
      />
    </svg>
  );
};

export default ShareScreenIcon;
